import moment from 'moment';
import { v4 as uuid4 } from 'uuid';
import { releases } from '../../../test.data';
import { ReleaseItem } from '../../../types/release.type';
import UserLinkButton from '../../button/user-link.button';
import Container from '../../containers/container';
import SpotifyEmbedded from '../../embedded/spotify.embedded';
import HorizontalBar from '../../horizontalBar';
import AlbumImage from '../../images/album.image';
import CoverImage from '../../images/cover.image';
import { HStack, VStack } from '../../layouts/stack.layout';
import Card from '../card';
import HeaderInfoCard from './info-card/header.info-card';
import { styles } from './info-card/styles';

type Props = {
  releaseId: string;
  close: Function;
};

export default function ReleaseInfoCard({ releaseId, close }: Props) {
  const release = releases.find((r) => r.id === releaseId);
  return (
    <>
      {release && (
        <Card className={styles.container}>
          <Card.Header className={styles.header}>
            <HeaderInfoCard title={release.title || ''} close={close} />
          </Card.Header>
          <Card.Body className={styles['alt-2-body']}>
            <VStack extensions="py-4">
              <VStack extensions="w-full" gap="base">
                <CoverImage src={release.cover} alt={release.title} />
                <UserLinkButton
                  to={release.artist.username}
                  user={release.artist}
                  variant="sm"
                />
              </VStack>
              <Container extensions="w-full mt-8">
                <HStack extensions="w-full justify-between font-text font-light text-primary text-xl">
                  <div>{release.artist.name}</div>
                  <div>{moment(release.date).format('MMM')}</div>
                </HStack>
                <HStack extensions="w-full justify-between font-text font-medium text-primary text-3xl">
                  <div className="w-3/4 text-ellipsis whitespace-nowrap overflow-hidden">
                    {release.title}
                  </div>
                  <div>{moment(release.date).format('DD')}</div>
                </HStack>
              </Container>
              {release.spotify && (
                <Container extensions="mt-8 w-full">
                  <SpotifyEmbedded
                    title={release.title}
                    variant={release.spotify.type}
                    id={release.spotify.id}
                  />
                </Container>
              )}
              <HorizontalBar spacing="lg" />
              <OtherReleasesSlider
                artistId={release.artist.username}
                currSongId={release.id}
              />
            </VStack>
          </Card.Body>
        </Card>
      )}
    </>
  );
}

function OtherReleasesSlider({
  artistId,
  currSongId,
}: {
  artistId: string;
  currSongId: string;
}) {
  const otherReleases: ReleaseItem[] = releases.filter(
    (r) => r.id !== currSongId && r.artist.username === artistId
  );

  if (!otherReleases.length) {
    return <></>;
  }

  return (
    <VStack gap="sm" extensions="w-full">
      <div className="font-text text-lg font-medium">
        More by {otherReleases[0].artist.name}
      </div>
      <HStack gap="base" extensions="overflow-auto w-full">
        {otherReleases.map((release) => (
          <VStack key={uuid4()} gap="xs">
            <AlbumImage
              src={release.cover}
              alt={release.title}
              className="release-card-img"
            />
            <div className="px-1 text-primary font-text text-sm overflow-hidden w-[150px] text-ellipsis whitespace-nowrap">
              {release.title}
            </div>
          </VStack>
        ))}
      </HStack>
    </VStack>
  );
}
